// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type DatevProtokolleListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetRechnungDatevProtokolle(): (
  rechnungId: string
) => Promise<DatevProtokolleListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (rechnungId) =>
      (await getAPI()).datev.getRechnungDatevProtokolle({ rechnungId }),
    [getAPI]
  );
}
